import * as React from 'react';
import { compose } from 'recompose';
import { InjectedFormProps } from 'redux-form';
import { reduxForm } from 'redux-form';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';

import * as actions from './actions';

import PATHS from '../../constants/paths';

import AuthForm from './AuthForm';

import { makeGetGlobalAuthFormErrors } from './selectors';

import IMPComponent from '../../components/interfaces/IMPComponent';

import withActionsDispatch from '../../hocs/withActionsDispatch';
import { authClearGlobalFormErrors } from './actions';

type IResetPasswordForm = IMPComponent;

interface IResetPasswordConnectedProps {
  submitResetPasswordForm: typeof actions.authSubmitResetPasswordForm;
  globalErrors: string[];
}

const MESSAGE_BASE = 'containers.Auth.ResetPasswordForm';

export const RESET_PASSWORD_FORM = 'resetPassword';

class ResetPasswordForm extends React.Component<
  IResetPasswordForm & IResetPasswordConnectedProps & InjectedIntlProps & InjectedFormProps
> {
  public render() {
    const { handleSubmit, intl, ...formProps } = this.props;

    return (
      <AuthForm
        passwordLess={true}
        linkPath={PATHS.AUTH.SIGN_IN}
        messageBase={MESSAGE_BASE}
        intl={intl}
        onSubmit={handleSubmit(this.onSubmit)}
        {...(formProps as any)}
      />
    );
  }

  private onSubmit = (values: any) => {
    const {
      submitResetPasswordForm,
      intl: { formatMessage },
    } = this.props;

    submitResetPasswordForm({
      successToastMessage: (
        <span
          dangerouslySetInnerHTML={{
            __html: formatMessage(
              {
                id: `${MESSAGE_BASE}.successToastMessage`,
              },
              {
                email: `<span class="Text--cerulean Text--medium">${values.email}</span>`,
              },
            ),
          }}
        />
      ),
    });
  };
}

const enhance = compose<IResetPasswordForm & IResetPasswordConnectedProps & InjectedIntlProps, IResetPasswordForm>(
  injectIntl,
  reduxForm({
    form: RESET_PASSWORD_FORM,
  }),
  connect(
    state => {
      return {
        globalErrors: makeGetGlobalAuthFormErrors(RESET_PASSWORD_FORM)(state),
      };
    },
    {
      submitResetPasswordForm: actions.authSubmitResetPasswordForm,
    },
  ),
  withActionsDispatch({
    onMount: [],
    onUnmount: [authClearGlobalFormErrors(RESET_PASSWORD_FORM)],
  }),
);
export default enhance(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/ResetPasswordForm.tsx